import React from 'react';

const ConfirmationPageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/confirmation',
			exact: true,
			component: React.lazy(() => import('./ConfirmationPage')),
		},
	],
};

export default ConfirmationPageConfig;
